export default "images/profile-vicky.png";